/*
 * Tabs script
 */
class ME_Accordions {
    constructor() {
        this.initState();
    }

    initState() {
        this.accordions = $('.accordion');
        this.current_tab = this.accordions.find('.current-tab');
        if (this.accordions.length) {
            this.initAccordionsEvents();
        }
    }

    initAccordionsEvents() {
        this.accordions.each(function(element){
           let accordion_container = $(this);
           let items = accordion_container.find('.accordion-item');
           items.on('click', function(){
              let data_number = $(this).data('number');
              let content_item = $('.accordion-content[data-number="'+data_number+'"]');
              if(content_item.length > 0){
                  items.removeClass('active');
                  $(this).addClass('active');
                  accordion_container.find('.accordion-content').removeClass('active');
                  content_item.addClass('active');

                  if(accordion_container.find('.current-tab').length > 0){
                      accordion_container.find('.current-tab').text($(this).text());
                  }
                  if(accordion_container.find('.categories').length > 0){
                      accordion_container.find('.categories').removeClass('active');
                  }
              }
           });
        });

        if(this.current_tab.length > 0){
            this.current_tab.each(function(element){
               $(this).on('click', function(){
                $(this).parent().find('.categories').addClass('active');
               });
            });
        }
    }
}
